import { normalizeUTCDateWithoutTime } from './utils'

export const profile = {
    gestorSistema: 'S',
    gestorOrgao: 'O',
    gestorRegional: 'R',
    atendente: 'A'
}

export const fluxoAtendimento = { }

export const estados = [
    { label: 'Acre', value: 'AC' },
    { label: 'Alagoas', value: 'AL' },
    { label: 'Amapá', value: 'AP' },
    { label: 'Amazonas', value: 'AM' },
    { label: 'Bahia', value: 'BA' },
    { label: 'Ceará', value: 'CE' },
    { label: 'Distrito Federal', value: 'DF' },
    { label: 'Espírito Santo', value: 'ES' },
    { label: 'Goiás', value: 'GO' },
    { label: 'Maranhão', value: 'MA' },
    { label: 'Mato Grosso', value: 'MT' },
    { label: 'Mato Grosso do Sul', value: 'MS' },
    { label: 'Minas Gerais', value: 'MG' },
    { label: 'Pará', value: 'PA' },
    { label: 'Paraíba', value: 'PB' },
    { label: 'Paraná', value: 'PR' },
    { label: 'Pernambuco', value: 'PE' },
    { label: 'Piauí', value: 'PI' },
    { label: 'Rio de Janeiro', value: 'RJ' },
    { label: 'Rio Grande do Norte', value: 'RN' },
    { label: 'Rio Grande do Sul', value: 'RS' },
    { label: 'Rondônia', value: 'RO' },
    { label: 'Roraima', value: 'RR' },
    { label: 'Santa Catarina', value: 'SC' },
    { label: 'São Paulo', value: 'SP' },
    { label: 'Sergipe', value: 'SE' },
    { label: 'Tocantins', value: 'TO' }
]

/**
 * console.log(statusOrgaoEnum.EM_CREDENCIAMENTO); // "EM_CREDENCIAMENTO"
 * console.log(statusOrgaoEnum.getLabels.EM_CREDENCIAMENTO); // "Em Credenciamento"
 * console.log(statusOrgaoEnum.getLabelByValue("EM_CREDENCIAMENTO")); // "Em Credenciamento"
 * console.log(statusOrgaoEnum.getValueByDate("2025-07-23")); // "EM_CREDENCIAMENTO" (data atual: "2025-07-22")
 * console.log(statusOrgaoEnum.getLabelByDate("2025-07-23")); // "Em Credenciamento" (data atual: "2025-07-22")
 */
export const statusOrgaoEnum = (() => {
	const enums = {
		CREDENCIADO: 'Credenciado',
		EM_CREDENCIAMENTO: 'Em Credenciamento',
		BLOQUEADO: 'Bloqueado'
	};
	const values = Object.entries(enums).map((key) => key[0]).reduce((acc, curr) => {
		  acc[curr] = curr;
		  return acc;
		}, {});

    return Object.freeze({
		...values,
		getLabels: enums,
    getLabelByValue: key => enums[key] || null,
    getLabelByDate: dateString => { //garante que as comparações sejam feitas apenas para dias cheios desconsiderando as horas.
      if (!dateString) return enums.EM_CREDENCIAMENTO;
      const inputUTCDateWithoutTime = normalizeUTCDateWithoutTime(new Date(dateString));  //Função "normalizeUTCDateWithoutTime" importante para evitar confusão com o fuso local do browser
      const currentUTCDateWithoutTime = normalizeUTCDateWithoutTime(new Date());          //Função "normalizeUTCDateWithoutTime" importante para evitar confusão com o fuso local do browser
      if (inputUTCDateWithoutTime > currentUTCDateWithoutTime) return enums.EM_CREDENCIAMENTO;
      if (inputUTCDateWithoutTime <= currentUTCDateWithoutTime) return enums.CREDENCIADO;
    }
    });
})();

/**
 * console.log(agencyScopeEnum.NACIONAL); // "NACIONAL"
 * console.log(agencyScopeEnum.getLabels.NACIONAL); // "Nacional"
 * console.log(agencyScopeEnum.getLabelByValue("NACIONAL")); // "Nacional"
 */
export const agencyScopeEnum = (() => {
	const enums = {
		NACIONAL: 'Nacional',
		ESTADUAL: 'Estadual',
		MUNICIPAL: 'Municipal'
	};
	const values = Object.entries(enums).map((key) => key[0]).reduce((acc, curr) => {
		  acc[curr] = curr;
		  return acc;
		}, {});

    return Object.freeze({
		...values,
		getLabels: enums,
    getLabelByValue: key => enums[key] || null
    });
})();
